module.exports = __webpack_public_path__ + "img/footer_javanan_10.be2e827b.svg";